import React, { useState, useEffect } from "react";
import {
  AccessTimeFilled,
  KeyboardArrowDownOutlined,
  KeyboardArrowUpOutlined,
  KeyboardArrowRightOutlined,
  KeyboardArrowLeftOutlined,
  Search,
} from "@mui/icons-material";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import './TeamReviewModals.css';

export default function DayOrders() {

  const token = sessionStorage.getItem("token");
  const tripId = sessionStorage.getItem("active_trip_id");
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTripId, setActiveTripId] = useState(tripId || null);
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDays, setSelectedDays] = useState("");
  const [daysDropdownOpen, setDaysDropdownOpen] = useState(false);
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  // Team review flow
  const [teamReviewOrderId, setTeamReviewOrderId] = useState(null);
  const [teamReviewOpen, setTeamReviewOpen] = useState(false);
  const [assignedStaff, setAssignedStaff] = useState([]);
  const [staffReviews, setStaffReviews] = useState({}); 
  const [loadingAssignedStaff, setLoadingAssignedStaff] = useState(false);
  const [staffRateOpen, setStaffRateOpen] = useState(false);
  const [activeStaff, setActiveStaff] = useState(null);
  const [activeRating, setActiveRating] = useState(0);
  const [activeReasons, setActiveReasons] = useState([]);
  const [activeComment, setActiveComment] = useState("");
  const [reviewReasons, setReviewReasons] = useState([]);
  const [loadingReasons, setLoadingReasons] = useState(false);
  const [submittingReviews, setSubmittingReviews] = useState(false);
  const [reviewSuccessOpen, setReviewSuccessOpen] = useState(false);
  
  const formatDate = (dateString) => {
    if (!dateString) return "تاريخ غير محدد";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatTime = (time) => {
    if (!time) return "";

    let date;

    if (time.includes("T")) {
      date = new Date(time);
    } else {
      date = new Date(`1970-01-01T${time}`);
    }

    return date.toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateTime = (dateTime) => {
    if (!dateTime) return "غير محدد";

    const date = new Date(dateTime);

    const formattedDate = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} - ${formattedTime}`;
  };

  const fetchOrders = async (date = "", days = "") => {
    try {
      const url = new URL(
        "https://estbn.com/EstbnNew/public/api/stuff/driver/orders",
      );
      if (date) {
        url.searchParams.append("date", date);
      }
      if (days) {
        url.searchParams.append("days", days);
      }
      const response = await fetch(url.toString(), {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      const result = await response.json();
      const ordersList = Array.isArray(result?.data?.orders)
        ? result.data.orders
        : Object.values(result?.data?.orders || {});
      ordersList.sort(
        (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
      );
      setOrders(ordersList);
      const currentOrder =
        ordersList.find((o) => o.status === "Dispatched") ||
        ordersList.find((o) => o.flags?.is_current);
      if (currentOrder) setExpandedOrderId(currentOrder.id);
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  console.log(orders);
  console.log("isArray:", Array.isArray(orders));

  const filteredOrders = Array.isArray(orders)
    ? orders.filter(
        (order) =>
          order.id?.toString().includes((searchTerm || "").toLowerCase()) ||
          order.address
            ?.toLowerCase()
            ?.includes((searchTerm || "").toLowerCase()),
      )
    : [];

  const hasActiveTrip = filteredOrders.some(
    (order) => order.status === "Dispatched",
  );

  const handleStartTrip = async (orderId) => {
    try {
      const formData = new FormData();
      formData.append("order_id", orderId);
      const response = await fetch(
        "https://estbn.com/EstbnNew/public/api/stuff/trips/start",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        },
      );
      console.log(response.data);
      const data = await response.json();
      if (response.ok) {
        const tripId = data?.data?.trip?.id;
        console.log("Returned Trip ID:", tripId);
        setActiveTripId(tripId);
        sessionStorage.setItem("active_trip_id", tripId);
        fetchOrders(selectedDate);
        console.log("Trip Started:", data);
        toast.success("Trip Started Successfully", { autoClose: 3000 });
      } else {
        toast.error(data.errors.message, { autoClose: 3000 });
        console.log("Start Trip Error:", data);
      }
    } catch (error) {
      console.error("Start Trip Failed:", error);
    }
  };

  const handleEndTrip = async (tripId, orderId) => {
    if (!tripId) {
      toast.error("Trip ID is null", { autoClose: 3000 });
      return;
    }
    try {
      const response = await fetch(
        `https://estbn.com/EstbnNew/public/api/stuff/trips/end/${tripId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await response.json();
      if (response.ok) {
        console.log("Trip Ended:", data);
        setActiveTripId(null);
        fetchOrders(selectedDate);
        toast.success("Trip Ended Successfully", { autoClose: 3000 });
        if (orderId) fetchAssignedStaff(orderId);
      } else {
        console.log("End Trip Error:", data);
      }
    } catch (error) {
      console.error("End Trip Failed:", error);
    }
  };

  const getButtonConfig = (order) => {
    const { status, flags } = order;

    if (status !== "Dispatched" && status !== "Assigned") {
      return {
        text: "تم إنهاء الرحلة بنجاح",
        style: { backgroundColor: "#0777da80", color: "white" },
        className: "",
        disabled: true,
        onClick: null,
      };
    }

    if (status === "Dispatched") {
      return {
        text: "إنهاء الرحلة",
        className: "btn-dark",
        style: {},
        disabled: false,
        onClick: () => handleEndTrip(activeTripId, order.id),
      };
    }

    if (status === "Assigned") {
      return {
        text: "ابدأ الرحلة",
        className: "btn-dark",
        style: {},
        disabled: !flags?.is_current || hasActiveTrip,
        onClick: () => handleStartTrip(order.id),
      };
    }

    return {
      text: "غير متاح",
      className: "btn-secondary",
      style: {},
      disabled: true,
      onClick: null,
    };
  };

  const fetchAssignedStaff = async (orderId) => {
    setLoadingAssignedStaff(true);
    try {
      const response = await fetch(
        `https://estbn.com/EstbnNew/public/api/stuff/get-stuff-assigned-to-vehicle/${orderId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      );
      const result = await response.json();
      if (result?.success) {
        setAssignedStaff(result?.data?.assignedStuff || []);
        setTeamReviewOrderId(orderId);
        setStaffReviews({});
        setTeamReviewOpen(true);
      }
    } catch (error) {
      console.error("Fetch Assigned Staff Failed:", error);
    } finally {
      setLoadingAssignedStaff(false);
    }
  };

  const fetchReviewReasons = async (rating) => {
    setLoadingReasons(true);
    const type = rating <= 2 ? "bad" : "good";
    try {
      const response = await fetch(
        `https://estbn.com/EstbnNew/public/api/stuff/review-reasons?type=${type}&reviewed_to=engineer`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        },
      );
      const result = await response.json();
      setReviewReasons(result?.data?.reasons || []);
    } catch (error) {
      console.error("Fetch Review Reasons Failed:", error);
      setReviewReasons([]);
    } finally {
      setLoadingReasons(false);
    }
  };

  const handleOpenStaffRate = (staff) => {
    const existing = staffReviews[staff.stuff_id];
    setActiveStaff(staff);
    setActiveRating(existing?.rating || 0);
    setActiveReasons(existing?.reasons || []);
    setActiveComment(existing?.comment || "");
    setReviewReasons([]);
    if (existing?.rating) fetchReviewReasons(existing.rating);
    setStaffRateOpen(true);
  };

  const handleSelectStar = (value) => {
    setActiveRating(value);
    setActiveReasons([]);
    fetchReviewReasons(value);
  };

  const toggleReason = (reasonId) => {
    setActiveReasons((prev) =>
      prev.includes(reasonId)
        ? prev.filter((id) => id !== reasonId)
        : [...prev, reasonId],
    );
  };

  const handleSaveStaffReview = () => {
    if (!activeStaff || !activeRating) return;
    setStaffReviews((prev) => ({
      ...prev,
      [activeStaff.stuff_id]: {
        staff: activeStaff,
        rating: activeRating,
        reasons: activeReasons,
        comment: activeComment,
      },
    }));
    setStaffRateOpen(false);
  };

  const handleSubmitAllReviews = async () => {
    const reviews = Object.values(staffReviews).map((r) => ({
      staff_id: r.staff.stuff_id,
      rating: r.rating,
      reasons: r.reasons,
      comment: r.comment,
    }));

    if (reviews.length === 0) {
      toast.error("قم بتقييم فرد واحد على الأقل", { autoClose: 3000 });
      return;
    }

    setSubmittingReviews(true);
    try {
      const response = await fetch(
        `https://estbn.com/EstbnNew/public/api/user/orders/${teamReviewOrderId}/review`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ type: "stuff", reviews }),
        },
      );
      const data = await response.json();
      if (response.ok && data?.success) {
        setTeamReviewOpen(false);
        setReviewSuccessOpen(true);
      } else {
        toast.error(data?.message || "حدث خطأ أثناء إرسال التقييم", {
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Submit Reviews Failed:", error);
      toast.error("حدث خطأ أثناء إرسال التقييم", { autoClose: 3000 });
    } finally {
      setSubmittingReviews(false);
    }
  };

  const resetTeamReviewState = () => {
    setTeamReviewOpen(false);
    setReviewSuccessOpen(false);
    setAssignedStaff([]);
    setStaffReviews({});
    setTeamReviewOrderId(null);
  };

  useEffect(() => {
    fetchOrders(selectedDate, selectedDays);
  }, [selectedDate, selectedDays]);

  return (
    <div className="w-100 py-4 px-3 px-md-4" dir="rtl">
      {/* orders harder */}
      <div className="text-end mb-4">
        <h5 className="fw-bold mb-3" style={{ fontSize: "1.1rem" }}>
          راجع الخدمات المنفذة من قبل الفني قبل تأكيد الطلب
        </h5>
        <div className="d-flex gap-2 flex-wrap">
          <div className="position-relative" style={{ width: "400px" }}>
            <input
              type="text"
              className="form-control pe-5 rounded-3 border-light-subtle shadow-sm"
              placeholder="ابحث برقم الطلب أو اسم الخدمة.."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Search
              className="position-absolute top-50 translate-middle-y text-muted"
              style={{ right: "15px" }}
            />
          </div>
          <input
            type="date"
            className="form-control rounded-3 border-light-subtle shadow-sm"
            style={{ width: "250px" }}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
          <div className="position-relative">
            <button
              type="button"
              onClick={() => setDaysDropdownOpen((prev) => !prev)}
              className="form-control rounded-3 border-light-subtle shadow-sm d-flex align-items-center justify-content-between bg-white"
              style={{ width: "200px", cursor: "pointer" }}
            >
              <span
                className={
                  selectedDays ? " fw-semibold text-dark" : "text-muted"
                }
              >
                {selectedDays
                  ? `عدد الأيام: ${selectedDays}`
                  : "اختر عدد الأيام"}
              </span>
              {daysDropdownOpen ? (
                <KeyboardArrowUpOutlined style={{ fontSize: "1.2rem" }} />
              ) : (
                <KeyboardArrowDownOutlined style={{ fontSize: "1.2rem" }} />
              )}
            </button>

            {daysDropdownOpen && (
              <>
                <div
                  onClick={() => setDaysDropdownOpen(false)}
                  style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 10,
                  }}
                />
                <div
                  className="shadow-lg rounded-4 bg-white border-0"
                  style={{
                    position: "absolute",
                    top: "calc(100% + 8px)",
                    right: 0,
                    zIndex: 20,
                    padding: "14px",
                    width: "300px",
                  }}
                >
                  <div
                    className="d-grid gap-2"
                    style={{ gridTemplateColumns: "repeat(6, 1fr)" }}
                  >
                    {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => {
                      const isSelected = Number(selectedDays) === day;
                      return (
                        <button
                          key={day}
                          type="button"
                          onClick={() => {
                            setSelectedDays(day);
                            setDaysDropdownOpen(false);
                          }}
                          className="rounded-3 border-0 fw-bold"
                          style={{
                            width: "38px",
                            height: "38px",
                            fontSize: "0.85rem",
                            backgroundColor: isSelected ? "#3EADA3" : "#f5f6f8",
                            color: isSelected ? "#fff" : "#333",
                            transition: "all 0.15s ease",
                          }}
                        >
                          {day}
                        </button>
                      );
                    })}
                  </div>

                  {selectedDays && (
                    <div className="text-center mt-2 pt-2 border-top">
                      <button
                        type="button"
                        onClick={() => {
                          setSelectedDays("");
                          setDaysDropdownOpen(false);
                        }}
                        className="btn btn-link btn-sm text-danger text-decoration-none p-0"
                      >
                        مسح الاختيار
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* orders list */}
      <div className="row g-3">
        <div className="col-12">
          {filteredOrders.map((order) => {
            const buttonConfig = getButtonConfig(order);
            return (
              <div
                key={order.id}
                className="mb-3 shadow-sm border-0 rounded-4 overflow-hidden bg-white"
              >
                {/* num & date */}
                <div
                  className="d-flex justify-content-between align-items-center p-3 bg-light cursor-pointer"
                  onClick={() =>
                    setExpandedOrderId(
                      expandedOrderId === order.id ? null : order.id,
                    )
                  }
                >
                  <div className="d-flex align-items-center gap-3">
                    <span className="text-muted small d-none d-sm-inline">
                      طلب رقم
                    </span>
                    <span className="fw-bold fs-6">#{order?.id}</span>
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        width: "28px",
                        height: "28px",
                      }}
                    >
                      <img
                        src={
                          order?.status_image ? (
                            `https://estbn.com/EstbnNew/public/storage/${order.status_image}`
                          ) : (
                            <AccessTimeFilled />
                          )
                        }
                        alt=""
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-bold">
                      {formatDate(order?.scheduled_date)}
                    </span>
                    {expandedOrderId === order.id ? (
                      <KeyboardArrowUpOutlined />
                    ) : (
                      <KeyboardArrowDownOutlined />
                    )}
                  </div>
                </div>
                {/* expand details */}
                {expandedOrderId === order.id && (
                  <div className="p-3 p-md-4 bg-white">
                    <div className="p-3 border rounded-4">
                      <div className="mb-3 text-end pb-2 border-bottom">
                        <span className="text-muted small">
                          الخدمة المطلوبة:{" "}
                        </span>
                        <span className="fw-bold text-dark">
                          {order.service_snapshot?.name || "خدمة صيانة"}
                        </span>
                      </div>

                      <div className="row g-3">
                        <div className="col-4 text-end">
                          <p className="text-muted small mb-1">حالة الطلب</p>
                          <p
                            className="fw-bold mb-0"
                            style={{
                              fontSize: "0.85rem",
                              color: `${order.status_color}`,
                            }}
                          >
                            {order.status}
                          </p>
                        </div>

                        <div className="col-4 border-end border-start">
                          <p className="text-muted small mb-1">الوقت</p>
                          <p
                            className="fw-bold mb-0"
                            style={{ fontSize: "0.85rem" }}
                          >
                            {order.trip_ended_at ? (
                              <>
                                تاريخ انتهاء الرحلة {"  "}
                                {formatDate(order.trip_ended_at)} -{" "}
                                {formatTime(order.trip_ended_at)}
                              </>
                            ) : order.trip_started_at ? (
                              <>
                                تاريخ بداية الرحلة{" "}
                                {formatDateTime(order.trip_started_at)}
                              </>
                            ) : (
                              <>
                                From {formatTime(order.scheduled_from)} To{" "}
                                {formatTime(order.scheduled_to)}
                              </>
                            )}
                          </p>
                        </div>

                        <div className="col-4">
                          <p className="text-muted small mb-1">العنوان</p>
                          <p
                            className="fw-bold mb-0 text-muted"
                            style={{
                              fontSize: "0.8rem",
                              lineHeight: "1.4",
                            }}
                          >
                            {order.address || "غير متوفر"}
                          </p>
                          {order.latitude && order.longitude && (
                            <button
                              type="button"
                              onClick={() => {
                                setSelectedLocation({
                                  latitude: order.latitude,
                                  longitude: order.longitude,
                                });
                                setMapModalOpen(true);
                              }}
                              className="small d-inline-flex align-items-center gap-1 border-0 bg-transparent p-0"
                              style={{
                                color: "#3EADA3",
                                fontWeight: 600,
                                textDecoration: "none",
                                marginTop: "4px",
                                cursor: "pointer",
                              }}
                            >
                              View on Map
                            </button>
                          )}
                        </div>
                      </div>

                      <div className="mt-4 pt-2 d-flex justify-content-center">
                        <button
                          className={`btn py-2 px-5 rounded-3 fw-bold w-25 ${buttonConfig.className}`}
                          style={buttonConfig.style}
                          disabled={buttonConfig.disabled}
                          onClick={buttonConfig.onClick}
                        >
                          {buttonConfig.text}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
          {filteredOrders.length === 0 && (
            <div className="text-center py-5 text-muted">
              لا توجد طلبات مطابقة للبحث
            </div>
          )}
        </div>
      </div>
      {/* location dialog */}
      <Dialog
        open={mapModalOpen}
        onClose={() => setMapModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent style={{ padding: 0, position: "relative" }}>
          <IconButton
            onClick={() => setMapModalOpen(false)}
            style={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1,
              background: "#fff",
            }}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          {selectedLocation && (
            <iframe
              title="order-location-map"
              src={`https://maps.google.com/maps?q=${selectedLocation.latitude},${selectedLocation.longitude}&z=16&output=embed`}
              width="100%"
              height="450"
              style={{ border: 0, display: "block" }}
              loading="lazy"
              allowFullScreen
            />
          )}
        </DialogContent>
      </Dialog>
      {/* ===== Team review — staff list ===== */}
      <Dialog
        open={teamReviewOpen}
        onClose={() => setTeamReviewOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "estbnTeamReview__dialogPaper" }}
      >
        <DialogContent className="estbnTeamReview__content" >
          <IconButton
            onClick={() => setTeamReviewOpen(false)}
            className="estbnTeamReview__closeBtn"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
          <div className="estbnTeamReview__header">
            <div className="estbnTeamReview__iconWrap">
              <GroupsRoundedIcon className="estbnTeamReview__headerIcon" />
            </div>
            <h5 className="estbnTeamReview__title">تقييم الفريق</h5>
            <p className="estbnTeamReview__subtitle">
              قيّم الفريق و ساعدنا في تحسين جودة الخدمة
            </p>
          </div>
         <div className="estbnTeamReview__list">
        {assignedStaff.map((staff) => {
          const savedReview = staffReviews[staff.stuff_id];
          return (
            <button
              type="button"
              key={staff.stuff_id}
              className="estbnTeamReview__row"
              onClick={() => handleOpenStaffRate(staff)}
            >
              <div className="estbnTeamReview__leftGroup">
                <KeyboardArrowLeftOutlined className="estbnTeamReview__rowArrow" />

                {savedReview && (
                  <span className="estbnTeamReview__rowStars">
                    {Array.from({ length: 5 }, (_, i) =>
                      i < savedReview.rating ? (
                        <StarRoundedIcon key={i} fontSize="small" />
                      ) : (
                        <StarBorderRoundedIcon key={i} fontSize="small" />
                      ),
                    )}
                  </span>
                )}
              </div>

              <div className="estbnTeamReview__rowRight">
                <div className="estbnTeamReview__rowInfo">
                  <span className="estbnTeamReview__rowName">{staff.stuff_name}</span>
                  <span className="estbnTeamReview__rowJob">
                    {staff.stuff_job_title}
                  </span>
                </div>

                {staff.profile_photo_path ? (
                  <img
                    className="estbnTeamReview__avatar"
                    src={`https://estbn.com/EstbnNew/public${staff.profile_photo_path}`}
                    alt={staff.stuff_name}
                  />
                ) : (
                  <div className="estbnTeamReview__avatarFallback">
                    {staff.stuff_name?.charAt(0)}
                  </div>
                )}
              </div>
            </button>
          );
        })}
        {loadingAssignedStaff && (
          <div className="estbnTeamReview__loading">جارِ التحميل...</div>
        )}
        </div>
          <button
            type="button"
            className="estbnTeamReview__submitBtn"
            disabled={
              Object.keys(staffReviews).length === 0 || submittingReviews
            }
            onClick={handleSubmitAllReviews}
          >
            {submittingReviews ? "جارِ الإرسال..." : "ارسال التقييمات"}
          </button>
        </DialogContent>
      </Dialog>
      {/* ===== Team review — single staff rating ===== */}
      <Dialog
        open={staffRateOpen}
        onClose={() => setStaffRateOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "estbnStaffRate__dialogPaper" }}
      >
        <DialogContent className="estbnStaffRate__content" dir="rtl">
          <div className="estbnStaffRate__topBar">
            <span className="estbnStaffRate__topBarSpacer" />
            <span className="estbnStaffRate__topTitle">تقييم الفريق</span>
              <IconButton
              onClick={() => setStaffRateOpen(false)}
              size="small"
              className="estbnStaffRate__backBtn"
            >
              <KeyboardArrowLeftOutlined fontSize="small" />
            </IconButton>
          </div>

          <p className="estbnStaffRate__hint">
            قيّم الفريق و ساعدنا في تحسين جودة الخدمة
          </p>

          {activeStaff && (
            <div className="estbnStaffRate__personRow">
              {activeStaff.profile_photo_path ? (
                <img
                  className="estbnStaffRate__personAvatar"
                  src={`https://estbn.com/EstbnNew/public${activeStaff.profile_photo_path}`}
                  alt={activeStaff.stuff_name}
                />
              ) : (
                <div className="estbnStaffRate__personAvatarFallback">
                  {activeStaff.stuff_name?.charAt(0)}
                </div>
              )}
              <div className="estbnStaffRate__personInfo">
                <span className="estbnStaffRate__personName">
                  {activeStaff.stuff_name}
                </span>
                <span className="estbnStaffRate__personJob">
                  {activeStaff.stuff_job_title}
                </span>
              </div>
            </div>
          )}

          <p className="estbnStaffRate__question">كيف كان التعاون معه ؟</p>

          <div className="estbnStaffRate__stars">
            {[1, 2, 3, 4, 5].map((value) => (
              <button
                type="button"
                key={value}
                className="estbnStaffRate__starBtn"
                onClick={() => handleSelectStar(value)}
              >
                {value <= activeRating ? (
                  <StarRoundedIcon className="estbnStaffRate__starFilled" />
                ) : (
                  <StarBorderRoundedIcon className="estbnStaffRate__starEmpty" />
                )}
              </button>
            ))}
          </div>

          {activeRating > 0 && (
            <div className="estbnStaffRate__reasonsBlock">
              <p className="estbnStaffRate__reasonsTitle">
                حدد الاسباب (اختياري)
              </p>

              <div className="estbnStaffRate__reasonsWrap">
                {loadingReasons ? (
                  <span className="estbnStaffRate__reasonsLoading">
                    جارِ التحميل...
                  </span>
                ) : (
                  reviewReasons.map((reason) => (
                    <button
                      type="button"
                      key={reason.id}
                      onClick={() => toggleReason(reason.id)}
                      className={`estbnStaffRate__reasonChip ${
                        activeReasons.includes(reason.id)
                          ? "estbnStaffRate__reasonChip--active"
                          : ""
                      }`}
                    >
                      {reason.reason_ar}
                    </button>
                  ))
                )}
              </div>

              <textarea
                className="estbnStaffRate__textarea"
                placeholder="اكتب ملاحظاتك هنا..."
                value={activeComment}
                onChange={(e) => setActiveComment(e.target.value)}
                rows={3}
              />
            </div>
          )}

          <button
            type="button"
            className="estbnStaffRate__saveBtn"
            disabled={!activeRating}
            onClick={handleSaveStaffReview}
          >
            حفظ التقييم
          </button>
        </DialogContent>
      </Dialog>
      {/* ===== Team review — success ===== */}
      <Dialog
        open={reviewSuccessOpen}
        onClose={resetTeamReviewState}
        maxWidth="sm"
        fullWidth
        PaperProps={{ className: "estbnReviewSuccess__dialogPaper" }}
      >
        <DialogContent className="estbnReviewSuccess__content" dir="rtl">
          <IconButton
            onClick={resetTeamReviewState}
            className="estbnReviewSuccess__closeBtn"
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <h5 className="estbnReviewSuccess__title">شكرا لتقييمك</h5>

          <div className="estbnReviewSuccess__checkWrap">
            <div className="estbnReviewSuccess__confetti">
              {Array.from({ length: 14 }, (_, i) => (
                <span
                  key={i}
                  className={`estbnReviewSuccess__confettiDot estbnReviewSuccess__confettiDot--${
                    i % 6
                  }`}
                />
              ))}
            </div>
            <CheckCircleRoundedIcon className="estbnReviewSuccess__checkIcon" />
          </div>

          <p className="estbnReviewSuccess__successText">
            تم استلام تقييمك بنجاح
          </p>
          <p className="estbnReviewSuccess__successSub">
            فريقنا يطلع على ملاحظاتك لتحسين الخدمة
          </p>

          <div className="estbnReviewSuccess__summaryCard">
            <span className="estbnReviewSuccess__summaryTitle">
              ملخص التقييم
            </span>

            {Object.values(staffReviews).map((r) => (
              <div
                className="estbnReviewSuccess__summaryRow"
                key={r.staff.stuff_id}
              >
                <span className="estbnReviewSuccess__summaryName">
                  {r.staff.stuff_name}
                </span>
                <span className="estbnReviewSuccess__summaryStars">
                  {Array.from({ length: 5 }, (_, i) =>
                    i < r.rating ? (
                      <StarRoundedIcon key={i} fontSize="small" />
                    ) : (
                      <StarBorderRoundedIcon key={i} fontSize="small" />
                    ),
                  )}
                </span>
              </div>
            ))}

            <div className="estbnReviewSuccess__summaryCount">
              عدد الأفراد الذين تم تقييمهم {Object.keys(staffReviews).length}/
              {assignedStaff.length}
            </div>
          </div>

          <button
            type="button"
            className="estbnReviewSuccess__backBtn"
            onClick={resetTeamReviewState}
          >
            العودة للصفحة الرئيسية
          </button>
        </DialogContent>
      </Dialog>
    </div>
  );
}
